import React, { ReactElement } from 'react';

import { Image, Text } from 'libComponents';

import styles from './StartPageCard.module.css';

import { ReactComponent as Next } from 'assets/img/items/next.svg';

import { IStartPageCardProps } from './types';

function StartPageCard({ dataLocator, onClick, img, title }: IStartPageCardProps): ReactElement {
    return (
        <div onClick={() => onClick()} data-locator={dataLocator} className={styles.card}>
            <Image src={img} alt="body" isForceVisible />
            <div className={styles.buttonBox}>
                <Text type="small-button" color="on-primary" className={styles.buttonText}>
                    {title}
                    <Next className={styles.nextIcon} />
                </Text>
            </div>
        </div>
    );
}

export default StartPageCard;
